/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetApartmentProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetApartment = ({
  streetName,
  cityName,
}: ContentStreetApartmentProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Apartments for rent in ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`If you're searching for apartments for rent in ${streetName}, then you've come
            to the right place. Apartments in ${streetName} are very popular as hundreds
            of people move to ${cityName} every year. Due to increasing demand, ${streetName}
            apartments for rent, remain the most searched ones on Kamernet. You
            can browse through our list of flats to rent at ${streetName} in ${cityName} and find
            more information about their size, rent and availability. If you are
            on the lookout for rental flats in ${streetName}, then you will find a range
            of affordable options to choose from. If you don't know where to
            find apartments to rent in ${streetName} then look no further, as Kamernet is
            the best website to find rental apartments in ${streetName} from both housing
            agencies and private owners.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Appartement te Huur ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Als je op zoek bent naar een appartement huren in ${streetName}, dan ben je
            hier aan het goede adres. Appartementen in ${streetName} zijn erg populair
            omdat er jaarlijks honderden mensen naar ${cityName} verhuizen. Door
            toenemende vraag blijven ${streetName} appartement te huur de meest gezochte
            woningen op Kamernet. U kunt door onze lijst met appartement huren
            in ${streetName} in ${cityName} bladeren en meer informatie vinden over hun grootte,
            huurprijs en beschikbaarheid. Als je op zoek bent naar huur
            appartement in ${streetName}, dan vind je een scala aan betaalbare opties om
            uit te kiezen. Als je niet weet waar je appartement te huur in ${streetName}
            kunt vinden, zoek dan niet verder, want Kamernet is de beste website
            om appartementen te huur in ${streetName} te vinden van zowel
            woningcorporaties als particuliere eigenaren.`}
      </Typography>
    </React.Fragment>
  );
};
